import { Instance } from 'mobx-state-tree';
import { VisitLocationDtoModelBase } from './VisitLocationDtoModel.base';

/* The TypeScript type of an instance of VisitLocationDtoModel */
export interface VisitLocationDtoModelType extends Instance<typeof VisitLocationDtoModel.Type> {}

/* A graphql query fragment builders for VisitLocationDtoModel */
export { selectFromVisitLocationDto, visitLocationDtoModelPrimitives, VisitLocationDtoModelSelector } from './VisitLocationDtoModel.base';

/**
 * VisitLocationDtoModel
 */
export const VisitLocationDtoModel = VisitLocationDtoModelBase
  .views(self => ({
    get displayAddress(): string {
      const originalAddress = self?.originalAddress;
      const address = self?.address;
      const latLng = `${self?.latitude}, ${self?.longitude}`;

      return originalAddress || address || latLng || '';
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
